import clsx from 'clsx';
import React from 'react';

const CheckoutSectionHeader = ({ children, className = '' }) => {
  return (
    <div
      className={clsx(
        className,
        'flex',
        'justify-between',
        'items-center',
        'mb-4'
      )}
    >
      {children}
    </div>
  );
};

export default CheckoutSectionHeader;
